import React from 'react'
import {
  Paper,
  Typography,
  Grid,
  Button,
  TextField,
  Chip,
  MenuItem,
  Select,
  Checkbox,
  ListItemText,
  FormControl,
  InputLabel
} from '@material-ui/core'
import generator from 'generate-password'
import SearchSelect from './SearchSelect'
import { MANAGE_USERS } from '../constants/permissions.json'

export default class UserModal extends React.Component {
  constructor(props) {
    super(props)

    this.onChange = this.onChange.bind(this)
    this.onSelect = this.onSelect.bind(this)
    this.onVendorChange = this.onVendorChange.bind(this)
    this.filterVendors = this.filterVendors.bind(this)
    this.filterEmployees = this.filterEmployees.bind(this)
    this.onSaveClick = this.onSaveClick.bind(this)

    const { vendors, employees } = this.props
    const { Username, Password, Permissions, VendorIdd, VendorName, Active, Email, EmployeeId } = props.modalUser || { Password: this.generatePassword() }

    this.vendorOptions = vendors.map(({ VendorID, VendorName }) => ({ label: `${VendorID} - ${VendorName}`, value: VendorID }))

    const vendor = vendors.find(v => v.VendorID === VendorIdd)
    const selectedVendor = vendor ? { label: `${vendor.VendorID} - ${vendor.VendorName}`, value: vendor.VendorID } : { label: '', value: '' }

    this.employeeOptions = employees.map(({ label, value }) => ({ label, value }))

    const employee = employees.find(e => e.value === EmployeeId)
    const selectedEmployee = employee || { label: '', value: '' }

    this.state = {
      Username, Password, Permissions, VendorIdd, VendorName, Active: Active === false ? 0 : 1, Email,
      selectedVendor, EmployeeId, selectedEmployee
    }
  }

  generatePassword() {
    return generator.generate(({ length: 7, numbers: true, symbols: true, excludeSimilarCharacters: true }))
  }

  onChange(prop) {
    return (e) => {
      this.setState({ [prop]: e.target.value })
    }
  }

  onSelect(prop) {
    return (e) => {
      this.setState({ [prop]: e.value, selectedEmployee: e })
    }
  }

  onVendorChange(option) {
    const { vendors } = this.props
    const { value, label } = option || {}
    const vendor = vendors.find(v => v.VendorID === value)
    this.setState({ VendorIdd: value, VendorName: vendor.VendorName, selectedVendor: { label, value: label } })
  }

  filterVendors(search) {
    return Promise.resolve(this.vendorOptions.filter(({ label }) => label.toLowerCase().includes(search.toLowerCase())).slice(0, 50))
  }

  filterEmployees(search) {
    return Promise.resolve(this.employeeOptions.filter(({ label }) => label.toLowerCase().includes(search.toLowerCase())).slice(0, 50))
  }

  onSaveClick() {
    const { user, upsertUser, hideModal } = this.props
    const { Username, Password, Permissions, VendorIdd, VendorName, Active, Email, EmployeeId } = this.state
    upsertUser(user, {
      Username,
      Password,
      Permissions: Permissions || [],
      VendorIdd: VendorIdd || 0,
      VendorName: VendorName || null,
      Email,
      Active,
      EmployeeId: EmployeeId || null
    })
      .catch(console.error)
      .finally(hideModal)
  }

  render() {
    const { modalUser, hideModal, allPermissions, user } = this.props
    const { Username, Password, Permissions, Active, Email, selectedVendor, selectedEmployee } = this.state
    const shouldAddUser = !modalUser
    const headerText = shouldAddUser ? 'Add User' : `Edit User: ${modalUser.Username}`
    const canManageUsers = user.permissions.includes(MANAGE_USERS)

    return (
      <Paper style={{ margin: 'auto', marginTop: '1%', width: 400, overflow: 'scroll' }}>
        <Typography style={{ padding: 10 }} variant="h4" color="primary">{headerText}</Typography>
        <Grid container style={{ display: 'flex', flexDirection: 'column', padding: 20, justifyContent: 'space-between', overflow: 'scroll' }}>
          <TextField
            style={{ marginTop: 20, width: 300 }}
            label="Username"
            value={Username}
            type="username"
            disabled={!shouldAddUser}
            onChange={this.onChange('Username')}
            autoComplete='off'
          />

          <TextField
            style={{ marginTop: 20, width: 300 }}
            label="Password"
            value={Password}
            onChange={this.onChange('Password')}
            autoComplete='off'
          />

          <TextField
            style={{ marginTop: 20, width: 300 }}
            label="Email"
            value={Email}
            onChange={this.onChange('Email')}
            autoComplete='off'
          />

          <FormControl style={{ marginTop: 20 }}>
            <InputLabel htmlFor="permissions">Permissions</InputLabel>
            <Select
              style={{ width: 300 }}
              multiple
              inputProps={{ id: 'permissions' }}
              value={Permissions || []}
              renderValue={selected => selected.map(value => <Chip key={value} label={value} />)}
              onChange={this.onChange('Permissions')}
              disabled={!canManageUsers}
            >
              {
                allPermissions.map(value => (
                  <MenuItem key={value} value={value}>
                    <Checkbox checked={Permissions && Permissions.indexOf(value) > -1} />
                    <ListItemText primary={value} />
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>

          <FormControl style={{ marginTop: 20 }}>
            <SearchSelect
              label="Vendor"
              defaultOptions={this.vendorOptions.slice(0, 50)}
              value={selectedVendor}
              onChange={this.onVendorChange}
              loadOptions={this.filterVendors}
              isDisabled={!canManageUsers}
            />
          </FormControl>

          <FormControl style={{ marginTop: 20 }}>
            <SearchSelect
              label="Employee"
              defaultOptions={this.employeeOptions.slice(0, 50)}
              value={selectedEmployee}
              onChange={this.onSelect('EmployeeId')}
              loadOptions={this.filterEmployees}
              isDisabled={!canManageUsers}
            />
          </FormControl>

          <FormControl style={{ marginTop: 20 }}>
            <InputLabel htmlFor="active">Active</InputLabel>
            <Select
              style={{ width: 300 }}
              inputProps={{ id: 'active' }}
              value={Active}
              onChange={this.onChange('Active')}
              disabled={!canManageUsers}
            >
              <MenuItem value={1}>Active</MenuItem>
              <MenuItem value={0}>Inactive</MenuItem>
            </Select>
          </FormControl>
        </Grid>

        <Grid container alignItems="flex-start" justify="flex-end" direction="row" style={{ padding: 10 }}>
          <Button style={{ marginRight: 10 }} onClick={hideModal}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={this.onSaveClick}>{shouldAddUser ? 'Add' : 'Save'}</Button>
        </Grid>
      </Paper>
    )
  }
}